/* eslint-disable no-unused-vars */
import '~/sass/pages/car-resume.scss';
import InputOtp from '@/components/input-otp';
import CarResumeExtent from '@/components/car-resume-extent';

const { $ } = window;

$(document).ready(() => {
  const otp = new InputOtp('#otpPhoneNumberGroup');
  const CarResume = new CarResumeExtent();
  console.log(CarResume.checkFormflag);

  $('#resumeInquireForm').on('submit', (event) => {
    event.preventDefault();

    $.fancybox.open({
      src: '#verifyPhoneNumber',
      type: 'inline',
      baseClass: 'fancybox-container-modal',
      touch: false,
      clickSlide: false,
      beforeShow() {
        $('#sentPhoneNumber').text($('#phoneNumber').val());
      },
      beforeClose() {
        $('#sentPhoneNumber').text('');
        if (otp) {
          otp.reset();
        }
      },
    });
  });
});
